/** Classic A: open dirt, boulders and diamonds - learn digging, falling and rolling (docs/spec/03 §2). */

import type { CaveDef } from '../types';

export const caveA: CaveDef = {
  id: 'A',
  name: 'FIRST STEPS',
  hint: 'Dig for diamonds, then run for the exit.',
  intermission: false,
  colors: [8, 12, 1],
  diamondValue: 10,
  extraValue: 15,
  fill: { base: '.', items: [['r', 10], ['d', 5], [' ', 2]] },
  levels: [
    { seed: 1101, diamonds: 12, time: 150 },
    { seed: 1102, diamonds: 14, time: 140 },
    { seed: 1103, diamonds: 16, time: 130 },
    { seed: 1104, diamonds: 18, time: 120 },
    { seed: 1105, diamonds: 20, time: 110 },
  ],
  // A clearing at the start with a diamond perched on a boulder stack, a cavern that fills as the
  // cave opens, and brick shelves to roll things off.
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.....r...?????????????????????????????W',
    'W.P...d...?????????????????????????????W',
    'W....rr...???       ???????????????????W',
    'W...wwww..???       ???????????????????W',
    'W.........???       ????wwwwwwwwwww????W',
    'W????????????d.r.d.r???????????????????W',
    'W???????????wwwwwwwww??????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W????????????????????wwwwwwwwwwwww?????W',
    'W??wwwwwwwwwww?????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W???????????????wwwwwwwwwwww???????????W',
    'W?????????????????????????????wwwwwww??W',
    'W????wwwwwwww??????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????X???W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
